module.exports = "/static/assets/0ff20e4e8ba2ba2ed8a7095b99add518.gif";